import * as moment from 'moment-timezone';
import {merge} from 'ramda';
import {BRANCH, COMMITHASH, GIT_VERSION, VERSION} from './gitConstants';
import localConfig from './localConfig';

const year = moment().year();
/* global VERSION, GIT_VERSION, COMMITHASH, BRANCH */
const appConfig = {
    version: VERSION,
    gitShortHash: GIT_VERSION,
    gitFullHash: COMMITHASH,
    gitBranch: BRANCH,
    isDevelopment: process.env.NODE_ENV === 'development',
    sagaUrl: 'http://localhost:5000/api', // do NOT add a trailing slaash
    sagaLogin: 'admin',
    sagaPassword: 'admin',
    sagaOfficeId: 129,

    dateTimeFormat: 'ddd, MMM Do YYYY, h:mm a',
    dateFormat: 'ddd, MMM Do YYYY',
    timeFormat: 'h:mm a',
    timeSFormat: 'h:mm:ss',

    siteConfig: {
        siteName: 'SAGA PROPERTIES',
        siteIcon: 'ion-flash',
        footerText: `Saga Property ©${year} By Softverk Ltd.`
    },
    themeConfig: {
        topbar: 'themedefault',
        sidebar: 'themedefault',
        layout: 'themedefault',
        theme: 'themedefault'
    },
    defaultLanguage: 'en', //  'en', 'zh', 'sa', 'it', 'es', 'fr', 'th'
    enabledLanguages: ['en', 'th', 'is'],

    googleConfig: {
        apiKey: 'AIzaSyAGvzEkM7Pp4ctnoOWToVUuip4wG_YOagA'
    },
    sharedKey: 'ZXCJQRk9QTEpNVU1DWUZCRVFGV1RMVB=',
    sharedIV: '1547895351547895',
    sagaWAPUrl: 'https://saga.softverk.co.th/SagaProperty',
    region: 'th-TH',
    uiLimitCharacters: 50,
    sagaApiCoreUrl: 'https://api.softverk.co.th/',
    vat: 7
};

export default merge(appConfig, localConfig);



// WEBPACK FOOTER //
// ./src/config/AppConfig.ts